import type { SharePort } from '../types';

function download(blob: Blob, fileName: string): void {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = fileName;
  a.click();
  setTimeout(() => {
    URL.revokeObjectURL(a.href);
  }, 1000);
}

/** Web Share Level 2 when the browser can share files, otherwise a download (ux-screens §3.11 S11a). */
export function createWebShare(): SharePort {
  return {
    async shareImage(blob, fileName, text) {
      const file = new File([blob], fileName, { type: blob.type });
      if (typeof navigator.canShare === 'function' && navigator.canShare({ files: [file] })) {
        try {
          await navigator.share({ files: [file], text });
          return 'shared';
        } catch (e) {
          if (e instanceof DOMException && e.name === 'AbortError') return 'cancelled';
        }
      }
      download(blob, fileName);
      return 'saved';
    },
    saveImage(blob, fileName) {
      download(blob, fileName);
      return Promise.resolve();
    },
  };
}
